import { defineMessages } from 'react-intl'

export default defineMessages({
  email: {
    id: 'form.validation.email',
    defaultMessage: 'Please provide a valid email address',
  },
  first_name: {
    id: 'form.validation.first_name',
    defaultMessage: 'Please enter a valid first name',
  },
  last_name: {
    id: 'form.validation.last_name',
    defaultMessage: 'Please enter a valid last name',
  },
  password: {
    id: 'form.validation.password',
    defaultMessage: 'Please enter a valid password',
  },
  passwordLength: {
    id: 'form.validation.passwordlength',
    defaultMessage: 'Password must be at least {length} letters',
  },
  passwordFormat: {
    id: 'form.validation.passwordformat',
    defaultMessage:
      'Password must contain a number, an uppercase letter and a lowercase letter',
  },
  date: {
    id: 'form.validation.date',
    defaultMessage: 'This combination is not a valid date',
  },
  dateMin: {
    id: 'form.validation.datemin',
    defaultMessage: 'Please enter a date after {minDate}',
  },
  dateMax: {
    id: 'form.validation.datemax',
    defaultMessage: 'Please enter a date before {maxDate}',
  },
  dateOfBirth: {
    id: 'form.validation.date_of_birth',
    defaultMessage: 'This combination is not a valid date of birth',
  },
  dateOfBirthV2: {
    id: 'form.validation.date_of_birth_v2',
    defaultMessage: 'This combination is not a valid date of birth',
  },
  dateOfBirthAgeOfConsent: {
    id: 'form.validation.dateofbirthageofconsent',
    defaultMessage:
      'You need to be at least {ageOfConsent} to sign up for this service',
  },
  dateOfBirthAgeTooOld: {
    id: 'form.validation.dateofbirthagetooold',
    defaultMessage: 'Please enter a year after {maxYearsForDateOfBirth}',
  },
  current_gp: {
    id: 'form.validation.current_gp',
    defaultMessage: 'Please select your current GP',
  },
  postcode: {
    id: 'form.validation.postcode',
    defaultMessage: 'Please enter a valid postcode',
  },
  zipcode: {
    id: 'form.validation.zipcode',
    defaultMessage: 'Please enter a valid ZIP code',
  },
  zipcodeFormat: {
    id: 'form.validation.zipcodeformat',
    defaultMessage: 'ZIP code needs to be 5 digits',
  },
  zipcodeInvalid: {
    id: 'form.validation.zipcodeinvalid',
    defaultMessage: 'This is not a valid ZIP code',
  },
  gender: {
    id: 'form.validation.gender',
    defaultMessage: 'Please select a gender',
  },
  phone_country_code: {
    id: 'form.validation.phone_country_code',
    defaultMessage: 'Please select a country',
  },
  phone_number: {
    id: 'form.validation.phone_number',
    defaultMessage: 'Please enter your phone number',
  },
  phone_number_invalid: {
    id: 'form.validation.phone_number_invalid',
    defaultMessage: 'Please enter a valid phone number',
  },
  phone_number_v2: {
    id: 'form.validation.phone_number_v2',
    defaultMessage: 'Please enter your phone number',
  },
  phone_number_v2_invalid: {
    id: 'form.validation.phone_number_v2_invalid',
    defaultMessage: 'Please enter a valid phone number',
  },
  address_state_code: {
    id: 'form.validation.address_state_code',
    defaultMessage: 'Please enter your state code',
  },
  genericFormError: {
    id: 'form.validation.genericformerror',
    defaultMessage: 'Please check all fields are correct',
  },
  insurerId: {
    id: 'form.validation.insurerid',
    defaultMessage: 'Please select an Insurance Provider',
  },
  planUuid: {
    id: 'form.validation.planuuid',
    defaultMessage: 'Please select an Insurance Plan',
  },
  externalInsuranceId: {
    id: 'form.validation.externalinsuranceid',
    defaultMessage: 'Please enter your Insurance ID',
  },
})
